import type { FC } from 'react';
import React, { memo, useContext, Fragment } from 'react';

import { ContextPanel } from '@atlaskit/editor-core';

import { EditorContextPanelContext } from './EditorContextPanelContext';

export const EditorContextPanelView: FC = memo(() => {
	const { item: contextPanelItem, editorAPI } = useContext(EditorContextPanelContext);

	let component;
	let hasPadding;
	let customWidth;

	if (contextPanelItem) {
		component = contextPanelItem.component;
		hasPadding = contextPanelItem.hasPadding;
		customWidth = contextPanelItem.customWidth;
	}

	return (
		<ContextPanel
			visible={!!contextPanelItem}
			editorAPI={editorAPI ?? undefined}
			hasPadding={hasPadding}
			customWidth={customWidth}
		>
			<Fragment>{component}</Fragment>
		</ContextPanel>
	);
});
